import { render, staticRenderFns } from "./WagonMobileService.vue?vue&type=template&id=0f2887a8&scoped=true"
import script from "./WagonMobileService.vue?vue&type=script&lang=js"
export * from "./WagonMobileService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2887a8",
  null
  
)

export default component.exports